module.exports = __webpack_public_path__ + "static/img/ruzhu_img_url1.4ac36726.png";